export const round = (amount: number): number => Math.round(amount * 100) / 100
